<template>
    <div class="overview" v-if="date !== null">
        <div class="page-header">
            <h1>
                {{date | moment('MMMM \'YY')}}&nbsp;

                <small class="controls">
                    <span class="pe-7s-angle-left-circle navigatable" @click="previous()"></span>&nbsp;
                    <span class="pe-7s-angle-right-circle navigatable" @click="next()"></span>
                </small>

                <small class="hidden-print">
                    <router-link :to="{name: 'reservations.create'}" class="btn btn-default btn-fill btn-sm">
                        <span class="fa fa-plus fa-fw"></span>
                        Add new
                    </router-link>
                </small>

                <small class="hidden-print" v-if="!isGroupedInvoice">
                    <button class="btn btn-default btn-fill btn-sm"  @click="groupInvoice">
                        Grouped invoice
                    </button>
                </small>

                <small class="hidden-print" v-else>
                    <button class="btn btn-primary btn-fill btn-sm" @click="groupInvoice">
                        Apply
                    </button>
                </small>

                <div class="pull-right">
                    <date-picker v-model="date" :config="{format: 'MMMM YYYY'}"></date-picker>
                </div>
            </h1>
        </div>

        <loader v-if="!hasLoaded" />

        <div class="calendar">
            <div>
                <header-block v-if="date && hasLoaded"
                              :date="date"
                />

                <room v-show="hasLoaded"
                      v-for="room in rooms"
                      :room="room"
                      :key="room.id"
                      :date="date"
                      @reservationsLoaded="loaded++"
                      :groupedInvoice="isGroupedInvoice"
                      :groupedReservations="groupedReservations"
                      @reservationsGroup="group"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .overview {
        .room {
        }

        .controls {
            > * {
                cursor: pointer;
            }
        }

        .calendar {
            overflow-x: scroll;

            > div {
                min-width: 1400px;
            }
        }
    }
</style>

<script>
    import HeaderBlock from '@/components/calendar/HeaderBlock'
    import Room from '@/components/calendar/Room'
    import Loader from '@/components/layout/Loader'

    const RoomService = require('@/services/rooms/RoomService')
    const moment = require('moment')

    import DatePicker from 'vue-bootstrap-datetimepicker'

    export default {
        data() {
            return {
                date: null,
                rooms: [],
                hasLoaded: false,
                loaded: 0,
                isGroupedInvoice: false,
                groupedReservations: {}
            }
        },

        watch: {
            loaded() {
                if (this.loaded !== this.rooms.length) {
                    return
                }

                this.hasLoaded = true
            }
        },

        mounted() {
            this.subscribe()
            this.load()
            this.setDefaultDate()
        },

        destroyed() {
            this.unsubscribe()
        },

        methods: {
            setDefaultDate() {
                this.date = moment()
            },

            previous() {
                this.reset()

                this.date = moment(this.date.subtract(1, 'month'))
            },

            /**
             * Next
             **/
            next() {
                this.reset()

                this.date = moment(this.date.add(1, 'month'))
            },

            reset() {
                this.hasLoaded = false
                this.loaded = 0
            },

            load() {
                RoomService.findAll({
                    sort: [{
                        key: 'order',
                        direction: 'ASC'
                    }]
                }, (response) => {
                    const data = response.data

                    this.rooms = data.rows
                })
            },

            subscribe() {
                var channel = this.$pusher.subscribe('cleanings')

                channel.bind('room.cleaned', (payload) => {
                    eventHub.$emit('room.cleaned', {room: payload.room})
                })
            },

            unsubscribe() {
                this.$pusher.unsubscribe('cleanings')
            },

            groupInvoice() {
                this.isGroupedInvoice = !this.isGroupedInvoice

                if (this.isGroupedInvoice) {
                    return
                }

                if (!Object.keys(this.groupedReservations).length) {
                    return
                }

                this.$router.push({
                    name: 'reservations.grouped',
                    query: {
                        ids: Object.keys(this.groupedReservations).join(',')
                    }
                })
            },

            group(reservation) {
                if (this.groupedReservations[reservation.id]) {
                    // remove
                    this.$delete(this.groupedReservations, reservation.id)
                    return
                }

                this.$set(this.groupedReservations, reservation.id, reservation)
            }
        },

        components: {
            Loader,
            HeaderBlock,
            Room,
            DatePicker
        }
    }
</script>



// WEBPACK FOOTER //
// Reservations.vue?027ca758